import request from "@/utils/request";

// 登录
export const login = async function (body: {}): Promise<any> {
  const url = `/uav/system/user/login`;
  const result = await request.post(url,body);
  return result.data;
};

// 获取用户详情
export const getOrgInfo = async function (body:{}): Promise<any> {
  const url = `/uav/system/org/orgList` ;
  const result = await request.post(url,body);
  return result.data;
};

// 获取用户信息
export const getUserInfo = async function (): Promise<any> {
  const url = `/uav/system/user/current`;
  const result = await request.get(url);
  return result.data;
};

// 市级
export const getCityList = async function (): Promise<any> {
  const url = `/uav/system/region/cityList/` + import.meta.env.VITE_APP_AREACODE;
  const result = await request.get(url);
  return result.data;
};

/**
 * 产品详情
 *
 * @param data
 */
export const getProductInfo = async function (productId:any): Promise<any> {
  const url = `/uav/system/product/info/` + productId;
  const result = await request.get(url);
  return result.data;
};

// 区县
export const getAreaList = async function (areaCode:any): Promise<any> {
  const url = `/uav/system/region/areaList/${areaCode}`;
  const result = await request.get(url);
  return result.data;
};

// 中队
export const getOrgList = async function (body:{}): Promise<any> {
  const url = `/uav/system/org/orgList`;
  const result = await request.post(url,body);
  return result.data;
};

//通知
export const getNoticeList = async function (body:{}): Promise<any> {
  const url = `/uav/notice/list`;
  const result = await request.post(url,body);
  return result.data;
};
